import { useQuery } from "@tanstack/react-query";

import { TGetOrganizationResDto } from "@/api/services/main/organization/dtos/get-organization.dto";
import { TUpdateOrganizationReqDto, TUpdateOrganizationResDto } from "@/api/services/main/organization/dtos/update-organization.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";

/**
 * Organization info is served by the account-backend main API:
 *   GET /organization  -> current user's organization
 *   PUT /organization  -> update (organization ADMIN only; backend returns 403 otherwise)
 */
export const fetchOrganizationApi = async (): Promise<TGetOrganizationResDto> => {
  const { data } = await clientApi.get<TGetOrganizationResDto>("/organization");
  return data;
};

export const useGetOrganization = (enabled = true) => {
  return useQuery({
    queryKey: [QUERY_KEYS.ORGANIZATION.FETCH_DETAIL],
    queryFn: () => fetchOrganizationApi(),
    enabled,
  });
};

export const updateOrganizationApi = async (payload: TUpdateOrganizationReqDto): Promise<TUpdateOrganizationResDto> => {
  const { data } = await clientApi.put<TUpdateOrganizationResDto>("/organization", payload);
  return data;
};
